// components/ConditionalHeader.tsx
'use client';

import { usePathname } from 'next/navigation';
import Header from "@/components/Header/Header";

export default function ConditionalHeader() {
  const pathname = usePathname();

  // Only show Header if not on the homepage
  if (pathname === '/') {
    return null;
  }

  return <Header />;
}
